export default __webpack_public_path__ + "static/freezelab-logo-b5c1f3b0acf269edb0d459abf135db78.svg";